// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"a32d44d1","453":"560891fd","641":"3778df7a","657":"169890c6","721":"c22fc01c","934":"11724f47"}[chunkId] + ".chunk.js";
};